import { Link, useLocation } from 'react-router-dom';
import { ListChecks } from 'lucide-react';
import { myWorkCountLabel, myWorkShownCount } from '../../lib/myWork/labels';
import { NavMenuIconLabel } from '../shell/NavMenuIconLabel';
import { cn } from '../ui/cn';

export const MY_WORK_PATH = '/my-work';

/**
 * Header and drawer entry for open work (PRO-3270, ADR-014 A19). The count is the
 * number still waiting. Opening the page does not clear it. Zero shows no number.
 */
export function MyWorkLink({
  total,
  variant,
  onNavigate,
  drawerLinkClassName,
}: {
  total: number | null;
  variant: 'header' | 'drawer';
  onNavigate?: () => void;
  drawerLinkClassName?: (active: boolean) => string;
}) {
  const { pathname } = useLocation();
  const active = pathname === MY_WORK_PATH;
  const label = myWorkCountLabel(total);
  const shown = myWorkShownCount(total);
  const count = shown ? (
    <span aria-hidden="true" className="ml-1 tabular-nums">
      {shown}
    </span>
  ) : null;

  if (variant === 'drawer') {
    return (
      <Link
        to={MY_WORK_PATH}
        aria-current={active ? 'page' : undefined}
        aria-label={label.accessibleName}
        onClick={onNavigate}
        className={drawerLinkClassName?.(active)}
      >
        <NavMenuIconLabel icon={ListChecks} active={active}>
          My work
          {count}
        </NavMenuIconLabel>
      </Link>
    );
  }

  return (
    <Link
      to={MY_WORK_PATH}
      aria-current={active ? 'page' : undefined}
      aria-label={label.accessibleName}
      className={cn(
        'hidden min-h-11 items-center rounded-md px-2 text-sm font-medium md:inline-flex',
        'underline-offset-2 hover:underline',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        active ? 'text-primary underline' : 'text-text-primary',
      )}
    >
      My work
      {count}
    </Link>
  );
}
